<template>
    <div class="watermark-container">
      <div class="content">
        <!-- 你的内容 -->
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MyComponent',
    mounted() {
      this.addWatermark('闲至优品');
    },
    methods: {
      addWatermark(text) {
        const canvas = document.createElement('canvas');
        canvas.width = 300;
        canvas.height = 200;
        const ctx = canvas.getContext('2d');
  
        ctx.font = '20px Arial';
        ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(-Math.PI / 4);
        ctx.fillText(text, 0, 0);
  
        const watermarkDiv = document.createElement('div');
        watermarkDiv.style.position = 'fixed';
        watermarkDiv.style.top = '0';
        watermarkDiv.style.left = '0';
        watermarkDiv.style.width = '100%';
        watermarkDiv.style.height = '100%';
        watermarkDiv.style.pointerEvents = 'none';
        watermarkDiv.style.backgroundImage = `url(${canvas.toDataURL('image/png')})`;
        watermarkDiv.style.zIndex = '9999';
        watermarkDiv.style.opacity = '0.5';
        watermarkDiv.style.backgroundRepeat = 'repeat';
  
        document.body.appendChild(watermarkDiv);
      }
    }
  }
  </script>
  
  <style>
  .watermark-container {
    position: relative;
    width: 100%;
    height: 100%;
  }
  
  .content {
    /* 你的内容样式 */
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/watermark.vue